// Polyfills
import 'babel-polyfill';
import 'nodelist-foreach-polyfill';

// Non-Vue
import Components from '@/components';
import Plugins from '@/plugins';

// Vue
import '@/_vue/mixins/global';
import Vue from 'vue';
import VueComponents from '@/_vue/components';
import VueStore from '@/_vue/store';
import i18n from '@/_vue/plugins/translations';
import '@/_vue/plugins/slick';
import '@/_vue/plugins/zoom';

// Non-Vue
Plugins();

// Vue
new Vue({ // eslint-disable-line no-new
    el: '#app',
    i18n,
    components: VueComponents,
    store: VueStore,
    mounted() {
        Components();

        const captcha = document.querySelector('.js-recaptcha');

        if (!captcha) return;
        captcha.querySelector('.btn').classList.add('disabled');

        this.handleCaptcha(captcha);
    },
    methods: {
        handleCaptcha(captcha) {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute('6LcS5PIUAAAAAKr2EU19Jr6nq7MymbXTyRsosqkx').then((token) => {
                    captcha.insertAdjacentHTML('beforeend', `<input type="hidden" name="g-recaptcha-response" value="${token}">`);
                    captcha.querySelector('.btn').classList.remove('disabled');
                });
            });
        },
    },
});
